var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.922 0H15.545V18.104H12.922V0ZM8.79599 12.94H11.419V15.51H8.79599V12.94ZM8.79599 5.903H11.419V11.349H8.79599V5.903ZM8.79599 17.1H11.419V22.546H8.79599V17.1ZM0.455986 5.896H3.07799V24H0.454987L0.455986 5.896ZM4.66899 8.455H7.29199V11.025H4.66999L4.66899 8.455ZM4.66899 12.606H7.29199V18.053H4.66999L4.66899 12.606ZM4.66899 1.419H7.29199V6.865H4.66999L4.66899 1.419Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.66e1024481d935dbf39fb736d0ae3750.svg";
export { ForwardRef as ReactComponent };